<template>
  <p-create v-if="$hasPermission('users.write')" />
  <p-not-found v-else />
</template>

<script>
import NotFound from './../components/NotFound.vue';
import CreateTeam from './../components/users/CreateTeam.vue';

export default {
  components: {
    'p-create': CreateTeam,
    'p-not-found': NotFound
  }
};
</script>
